export default __webpack_public_path__ + "static/media/red-bin-icon.874b8025.svg";